import React, { memo } from 'react';
import { HeartIcon, Leaf, UsersIcon } from 'lucide-react';
const ValueCards = () => {
  return <section className="py-20 bg-white" data-id="element-946">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-947">
        <div className="text-center mb-16" data-id="element-948">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-949">
            Why Leading Educational Institutions Choose SmartSoda
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-950">
            The healthy hydration solution that students love and parents trust
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-951">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-952">
            <div className="mb-6 bg-blue-50 p-4 rounded-full" data-id="element-953">
              <HeartIcon className="h-8 w-8 text-blue-600" data-id="element-954" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-955">
              Student Health & Wellness
            </h3>
            <p className="text-gray-600 text-center" data-id="element-956">
              Provide healthy, zero-calorie hydration options that support
              student wellness, focus, and performance—without the sugar and
              artificial ingredients found in typical drinks.
            </p>
          </div>
          {/* Card 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-957">
            <div className="mb-6 bg-green-50 p-4 rounded-full" data-id="element-958">
              <Leaf className="h-8 w-8 text-green-600" data-id="element-959" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-960">
              Environmental Education
            </h3>
            <p className="text-gray-600 text-center" data-id="element-961">
              Teach sustainability by example—eliminate single-use plastic
              bottles and reduce your facility's environmental footprint by up
              to 90% while providing better hydration.
            </p>
          </div>
          {/* Card 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-962">
            <div className="mb-6 bg-amber-50 p-4 rounded-full" data-id="element-963">
              <UsersIcon className="h-8 w-8 text-amber-600" data-id="element-964" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-965">
              Parent Satisfaction
            </h3>
            <p className="text-gray-600 text-center" data-id="element-966">
              Delight parents with premium beverage options during visits while
              demonstrating your commitment to their children's health and the
              environment.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-967">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-968">
            Transform Your Facility's Hydration
          </a>
        </div>
      </div>
    </section>;
};
export default ValueCards;